export default "__VITE_ASSET__b70Hjm8N__"